// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"ad00268e","374":"9362295e"}[chunkId] + ".chunk.css";
};